window.addEventListener("load", function() {
    const thumbsWeaponSwiper = new Swiper("#swiperWeaponThumb", {
        slidesPerView: "auto",
        spaceBetween: 10,
        slideToClickedSlide: true,
        centeredSlides: false,
        centerInsufficientSlides: false,
    });

    const swiperWeapon = new Swiper("#swiperWeapon", {
        slidesPerView: "auto",
        centeredSlides: true,
        spaceBetween: 0,
        effect: "fade",
        fadeEffect: {
            crossFade: true,
        },
        thumbs: {
            swiper: thumbsWeaponSwiper,
        },
        speed: 0,
        on: {
            slideChangeTransitionStart: function() {
                const activeSlide = this.slides[this.activeIndex];

                if (activeSlide) {
                    const img = activeSlide.querySelector('img');
                    const info = activeSlide.querySelector('.box__info');

                    if (img) {
                        img.style.animation = 'none';
                        setTimeout(() => {
                            img.style.animation = 'slideUpFade 0.6s ease-out forwards';
                        }, 10);
                    }

                    if (info) {
                        info.style.animation = 'none';
                        setTimeout(() => {
                            info.style.animation = 'slideUpFade 0.6s ease-out 0.2s forwards';
                        }, 10);
                    }
                }

                // Update tab active state based on slide index
                const tabCanchien = document.querySelector('.item__canchien');
                const tabTamxa = document.querySelector('.item__tamxa');

                if (tabCanchien && tabTamxa) {
                    if (this.activeIndex < 16) {
                        tabCanchien.classList.add('active');
                        tabTamxa.classList.remove('active');
                    } else {
                        tabCanchien.classList.remove('active');
                        tabTamxa.classList.add('active');
                    }
                }

                // Auto scroll thumbs smoothly when active slide changes
                const activeIndex = this.activeIndex;
                const totalSlides = thumbsWeaponSwiper.slides.length;
                const firstThumbSlide = thumbsWeaponSwiper.slides[0];

                if (firstThumbSlide && thumbsWeaponSwiper.width) {
                    const visibleSlides = Math.floor(thumbsWeaponSwiper.width / (firstThumbSlide.offsetWidth + 10));

                    // Calculate if we need to scroll
                    if (activeIndex >= visibleSlides - 2 && activeIndex < totalSlides - 1) {
                        // Smooth scroll to show next items
                        thumbsWeaponSwiper.slideTo(activeIndex - visibleSlides + 3, 600);
                    } else if (activeIndex < 2) {
                        // Scroll back to beginning
                        thumbsWeaponSwiper.slideTo(0, 500);
                    }
                }
            }
        }
    });

    // Trigger animation for first slide
    const firstSlide = swiperWeapon.slides[swiperWeapon.activeIndex];

    if (firstSlide) {
        const firstImg = firstSlide.querySelector('img');
        const firstInfo = firstSlide.querySelector('.box__info');

        if (firstImg) {
            firstImg.style.animation = 'slideUpFade 0.4s ease-out forwards';
        }
        if (firstInfo) {
            firstInfo.style.animation = 'slideUpFade 0.4s ease-out forwards';
        }
    }

    // Set initial active tab
    const tabCanchien = document.querySelector('.item__canchien');
    const tabTamxa = document.querySelector('.item__tamxa');

    if (tabCanchien) {
        tabCanchien.classList.add('active');

        // Handle tab clicks
        tabCanchien.addEventListener('click', function(e) {
            e.preventDefault();
            swiperWeapon.slideTo(0);
        });
    }

    if (tabTamxa) {
        tabTamxa.addEventListener('click', function(e) {
            e.preventDefault();
            swiperWeapon.slideTo(16);
        });
    }
});